import { DEFAULT_JOINT_COLOR } from '../../utils/constants';
import Entity, { IEntity } from '../abstract/Entity';
import { IAttribute } from './AttributeModel';

export interface ITile extends IEntity {
  length: number;
  width: number;
  rotation: number;
  jointWidth: number;
  jointColor: string;
}

class TilesModel extends Entity implements ITile {
  length: number;

  width: number;

  rotation: number;

  jointWidth: number;

  jointColor: string;

  constructor(
    length: number,
    width: number,
    rotation = 0,
    jointWidth = 1,
    jointColor = DEFAULT_JOINT_COLOR,
    attributes: Array<IAttribute> = [],
    uuid: string | undefined = undefined,
  ) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.length = length;
    this.width = width;
    this.rotation = rotation;
    this.jointWidth = jointWidth;
    this.jointColor = jointColor;
  }

  getLength(): number {
    return this.length;
  }

  setLength(length: number): void {
    this.length = length;
  }

  getWidth(): number {
    return this.width;
  }

  setWidth(width: number): void {
    this.width = width;
  }

  getRotation(): number {
    return this.rotation;
  }

  setRotation(rotation: number): void {
    this.rotation = rotation;
  }

  getJointWidth(): number {
    return this.jointWidth;
  }

  setJointWidth(jointWidth: number): void {
    this.jointWidth = jointWidth;
  }

  getJointColor(): string {
    return this.jointColor;
  }

  setJointColor(jointColor: string): void {
    this.jointColor = jointColor;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      length: this.length,
      width: this.width,
      rotation: this.rotation,
      jointWidth: this.jointWidth,
      jointColor: this.jointColor,
    };
  }
}

export default TilesModel;
